module.exports = __webpack_public_path__ + "img/WM22_Whitelabel_400x416@2x.299d6acc.jpg";